import { BadgeType } from '@@/Badge';

import {
  AlertRuleRow,
  AlertRuleTier,
  TierSeverity,
  TIER_SEVERITY_ORDER,
} from './types';
import { convertBytesToHumanReadable } from './bytes';

export const severityConfig: Record<
  TierSeverity,
  { label: string; badgeType: BadgeType }
> = {
  critical: { label: 'Critical', badgeType: 'danger' },
  warning: { label: 'Warning', badgeType: 'warn' },
  info: { label: 'Info', badgeType: 'info' },
};

export function severityToBadgeType(
  severity: AlertRuleRow['severity']
): BadgeType {
  return severityConfig[severity]?.badgeType ?? 'info';
}

export function severityToTextColour(
  severity: AlertRuleRow['severity']
): string {
  switch (severity) {
    case 'critical':
      return 'text-danger';
    case 'warning':
      return 'text-warning';
    case 'info':
    default:
      return 'text-info';
  }
}

export function canonicalizeAlertRuleTiers(
  tiers: AlertRuleTier[] = []
): AlertRuleTier[] {
  const bySeverity: Partial<Record<TierSeverity, AlertRuleTier>> = {};

  for (const tier of tiers) {
    bySeverity[tier.severity] = tier;
  }

  return TIER_SEVERITY_ORDER.map(
    (severity) =>
      bySeverity[severity] ?? {
        severity,
        threshold: 0,
        enabled: false,
      }
  );
}

export function metricTypeToSymbol(
  metricType: AlertRuleRow['metricType']
): string {
  return metricType === 'percentage' ? '%' : '';
}

export function formatThreshold(
  threshold: number,
  metricType: AlertRuleRow['metricType']
): string {
  switch (metricType) {
    case 'percentage':
      return `${threshold}%`;
    case 'bytes': {
      const { value, unit } = convertBytesToHumanReadable(threshold);
      return `${value} ${unit}`;
    }
    case 'days':
      return `${threshold} days`;
    case 'raw':
    case undefined:
    default:
      return `${threshold}`;
  }
}
